export default __webpack_public_path__ + "static/media/modal-icon-offer.207741ff.svg";